export const categoryVI = {
  "categoryConfig": {
    "header": {
      "bonusMethod": "Hình thức khen thưởng",
      "reprimandMethod": "Hình thức kỷ luật",
      "receiptProcedures": "Thủ tục tiếp nhận",
      "severanceProcedures": "Thủ tục thôi việc",
      "add": "Thêm danh mục",
      "update": "Cập nhật danh mục",
      "category" : "Danh mục",
      "addBonusMethod": " Thêm hình thức khen thưởng",
      "addReprimandMethod": "Thêm hình thức kỷ luật",
      "addReceiptProcedures": "Thêm thủ tục tiếp nhận",
      "addSeveranceProcedures": "Thêm thủ tục thôi việc",
      "updateBonusMethod": "Cập nhật hình thức khen thưởng",
      "updateReprimandMethod": "Cập nhật hình thức kỷ luật",
      "updateReceiptProcedures": "Cập nhật thủ tục tiếp nhận",
      "updateSeveranceProcedures": "Cập nhật thủ tục thôi việc"
    },
    "title": {
      "name": "Tên hình thức",
      "description": "Mô tả"
    },
    "placeHolder": {
      "name": "Nhập tên hình thức",
      "description": "Nhập mô tả"
    },
    "message": {
      "add": "Thêm thành công",
      "update": "Cập nhật thành công",
      "delete": "Xóa thành công"
    },
    "btn": {
      "add": "Tạo mới",
      "update": "Cập nhật",
      "delete": "Xóa thành công"
    }

  }
}